import { sendForgotPasswordOtp } from "@/lib/api/auth-actions";
import { philosopher } from "@/lib/fonts";
import { zodResolver } from "@hookform/resolvers/zod";
import { forgotPasswordSendOtpInputSchema } from "muminsmart-utils";
import React from "react";
import { useForm } from "react-hook-form";
import { toast } from "sonner";
import z from "zod";
import {
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  FormControl,
  Form,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

interface ForgotPasswordProps {
  handleNextStep: React.Dispatch<
    Partial<{ email: string; otp: string; password: string }>
  >;
}

const ForgotPasswordSendOtp: React.FC<ForgotPasswordProps> = ({
  handleNextStep,
}) => {
  const [loading, setLoading] = React.useState(false);
  const form = useForm<z.infer<typeof forgotPasswordSendOtpInputSchema>>({
    resolver: zodResolver(forgotPasswordSendOtpInputSchema),
    defaultValues: {
      email: "",
    },
  });

  const onSubmit = async (
    values: z.infer<typeof forgotPasswordSendOtpInputSchema>,
  ) => {
    setLoading(true);
    sendForgotPasswordOtp(values.email)
      .then((res) => {
        if (res.success) {
          toast.success(res.message);
          handleNextStep({
            email: values.email,
          });
        } else {
          toast.error(res.message);
        }
      })
      .catch((error) => {
        toast.error(error.message || "Failed to send OTP. Please try again.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="px-5">
      <h1
        className={`text-center text-secondary text-3xl font-semibold ${philosopher.className} mb-3`}
      >
        <span>Forgot </span>
        <span className="text-primary">Password</span>
      </h1>
      <p className="text-[#6f6f6f] text-center text-sm mt-2 mb-10">
        Enter your email and reset password to get back into your account
      </p>

      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-5">
          <FormField
            control={form.control}
            name="email"
            render={({ field }) => (
              <FormItem>
                <FormLabel className="font-medium">Email Id</FormLabel>
                <FormControl>
                  <Input
                    placeholder="example@gmail.com"
                    className="rounded-full p-5 bg-white"
                    {...field}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <Button
            type="submit"
            className="w-full rounded-full bg-primary py-4 text-lg"
            disabled={loading}
          >
            {loading ? "Sending OTP" : "Verify"}
          </Button>
        </form>
      </Form>
    </div>
  );
};

export default ForgotPasswordSendOtp;
